import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { AuthGuard } from '@onesource/components';
import { DashboardLayout } from 'src/layouts/dashboard';

export const Route = createFileRoute('/apps')({
  component: () => (
    <DashboardLayout>
      <AuthGuard>
        <AppsPage />
      </AuthGuard>
    </DashboardLayout>
  ),
});

const AppsPage = lazyRouteComponent(() => import('src/pages/apps'));
